export enum DynamicListBulletStyle {
  Circle = 1,
  Disc = 2,
  Square = 3,
}

export const DynamicListBulletStyleToString = {
  [DynamicListBulletStyle.Circle]: "Circle",
  [DynamicListBulletStyle.Disc]: "Disc",
  [DynamicListBulletStyle.Square]: "Square"
}